import { evaluateCan } from "@/permissions/v2/can";
import type { EffectivePermission, MeResponse, PermissionContext } from "@/permissions/v2/types";
import type { APIInstance } from "@/services/apiService";
import { MeService } from "@/services/meService";
import { create } from "zustand";

interface PermissionsV2State {
  permissions: EffectivePermission[];
  isLoaded: boolean;
  setPermissions: (permissions: EffectivePermission[]) => void;
  clearPermissions: () => void;
  loadFromApi: (api: APIInstance) => Promise<void>;
  can: (resource: string, action: string, ctx?: PermissionContext) => boolean;
}

export const usePermissionsV2Store = create<PermissionsV2State>((set, get) => ({
  permissions: [],
  isLoaded: false,
  setPermissions: (permissions) => set({ permissions, isLoaded: true }),
  clearPermissions: () => set({ permissions: [], isLoaded: false }),
  loadFromApi: async (api) => {
    const meService = new MeService(api);
    const me: MeResponse = await meService.getMe();
    set({ permissions: me.permissions, isLoaded: true });
  },
  can: (resource, action, ctx) => evaluateCan(get().permissions, resource, action, ctx),
}));
